// AgentChip.jsx — agent 徽标的**唯一**实现（第一百零四批收成共享件）。
//
// SB-091 §4③ 的整个意义就是"agent 写的东西在界面上查得出来"：viaAgent 是服务端
// 由**凭据**推导的（dck_ key 写入 ⇒ true，会话/密码写入 ⇒ false，不可自称），
// 页面把它显示出来才让那条推导有落点。第一百零二批它先以页内私有组件出现在汇报
// 读面；本批组间通信的消息流需要同一枚徽标——同一条规则两份手写实现就会漂
// （第五十六批导航清单付过的账），所以趁第二个调用点出现把它收成一件。
// 两个面（汇报修订、线内消息）必须长得一样：读者靠这枚徽标建立"这是 agent 写的"
// 的识别，形状一漂识别就断。
import { Chip } from '@mui/material';
import { useT } from '../i18n/index.mjs';

export default function AgentChip() {
  const t = useT();
  return (
    <Chip
      size="small"
      variant="outlined"
      color="secondary"
      label={t('agent.badge')}
      title={t('agent.badgeHint')}
    />
  );
}
